import axios from "axios";
import Swal from "sweetalert2";

// Constants
const API_BASE_URL = "https://campus.acetians.in/api/v2/admission/save";

 

export const showErrorAlert = (message, focusElementId) => {
  Swal.fire({
    icon: "error",
    title: "Validation Error",
    text: message,
    confirmButtonColor: "#3085d6",
  }).then(() => {
    if (focusElementId) {
      const element = document.getElementById(focusElementId);
      if (element) {
        element.focus();
      }
    }
  });
};

export const showSuccessAlert = (message) => {
  Swal.fire({
    icon: "success",
    title: "Success",
    text: message,
    confirmButtonColor: "#3085d6",
  });
};

export const showLoading = () => {
  Swal.fire({
    title: "Saving Data...",
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });
};

export const closeLoading = () => {
  Swal.close();
};

export const FormService = {
  async submitForm(formData,course) {
    console.log(formData.high_school_year)
    try {
      console.log("data forn banne ko aya",formData)

      
      const formDataToSend = new FormData();

  

      if(formData.part === 2){
        formDataToSend.append("ug_1styear", formData.ug_1styear??"");
        formDataToSend.append("ug_board", formData.ug_board??"");
         formDataToSend.append("ug_name", formData.ug_name??"");

             formDataToSend.append("ug_1styear_rollno", formData.ug_1styear_rollno??"");
             
             formDataToSend.append("ug_1styear_maxmarks", formData.ug_1styear_maxmarks??"");

               formDataToSend.append("ug_1styear_obtmarks", formData.ug_1styear_obtmarks??"");

               
    formDataToSend.append("ug_1styear_percentage", formData.ug_1styear_percentage??"");

     formDataToSend.append("first_sem_sub", formData.first_sem_sub??"");

      formDataToSend.append("second_sem_sub", formData.second_sem_sub??"");




      }


      formDataToSend.append("course", course);
      formDataToSend.append("part", formData.part??"");
      formDataToSend.append("urn", formData.urn??"");
      formDataToSend.append("applicant_name", formData.applicant_name??"");
      formDataToSend.append("mother_name", formData.mother_name??"");
      formDataToSend.append("father_name", formData.father_name??"");
      formDataToSend.append("dob", formData.dob);
      formDataToSend.append("gender", formData.gender??"");
      formDataToSend.append("religion", formData.religion??"");
      formDataToSend.append("minor_subject", formData.minor_subject??"");
      formDataToSend.append("second_major_subject", formData.second_major_subject??"");
      formDataToSend.append("first_major_subject", formData.first_major_subject??"");
      formDataToSend.append("category", formData.category??"");
      formDataToSend.append("sub_category", formData.sub_category || "");
      formDataToSend.append("email", formData.email??"");
      formDataToSend.append("whatsapp_number", formData.whatsapp_number??"")
      formDataToSend.append("applicant_mobile", formData.applicant_mobile??"");
      formDataToSend.append("aadhar_no", formData.aadhar_no??"");
       

      // Address Details
      formDataToSend.append("c_address", formData.c_address??"");
      formDataToSend.append("p_address", formData.p_address??"");
      formDataToSend.append(
        "same_as_correspondence",
        formData.same_as_correspondence ? "1" : "0"
      );
      formDataToSend.append(
        "local_guardian_name",
        formData.local_guardian_name || ""
      );
      formDataToSend.append(
        "local_guardian_address",
        formData.local_guardian_address || ""
      );
      formDataToSend.append(
        "local_guardian_contact",
        formData.local_guardian_contact || ""
      );

      // Eligibility
      formDataToSend.append("nationality", formData.nationality??"");
      formDataToSend.append("is_minority", formData.is_minority??"");
      formDataToSend.append("is_otherenrollment", formData.is_otherenrollment??"");
      formDataToSend.append("is_upresidence", formData.is_upresidence??"");

      // Handle arrays for horizontal_reservation and weightage
      if (Array.isArray(formData.horizontal_reservation)) {
        formData.horizontal_reservation.forEach((item) => {
          formDataToSend.append("horizontal_reservation[]", item);
        });
      }

      if (Array.isArray(formData.weightage)) {
        formData.weightage.forEach((item) => {
          formDataToSend.append("weightage[]", item);
        });
      }

      // Income Details
      formDataToSend.append("annual_income", formData.annual_income??"");
      formDataToSend.append(
        "income_certificate_no",
        formData.income_certificate_no
      ??"");
      formDataToSend.append("bank_name", formData.bank_name??"");
      formDataToSend.append("bank_branch", formData.bank_branch??"");
      formDataToSend.append("bank_account", formData.bank_account??"");
      formDataToSend.append("bank_isfsc", formData.bank_isfsc??"");

      // Education Details
      // High School
      formDataToSend.append("high_school_year", formData.high_school_year||"");
      formDataToSend.append("high_school_board", formData.high_school_board||"");
      formDataToSend.append(
        "high_school_name",
        formData.high_school_name||""
      );
      formDataToSend.append(
        "high_school_roll",
        formData.high_school_roll
      ??"");
      formDataToSend.append(
        "high_school_maxmarks",
        formData.high_school_maxmarks
      ??"");
      formDataToSend.append(
        "high_school_obtmarks",
        formData.high_school_obtmarks
      ??"");
      formDataToSend.append(
        "high_school_percentage",
        formData.high_school_percentage || ""
      );
      formDataToSend.append(
        "high_school.subject",
        formData.high_school_subject || ""
      );

      // Intermediate
      formDataToSend.append("intermediate_year", formData.intermediate_year??"");
      formDataToSend.append("intermediate_board", formData.intermediate_board??"");
      formDataToSend.append(
        "intermediate_name",
        formData.intermediate_name
      ??"");
      formDataToSend.append(
        "intermediate_roll",
        formData.intermediate_roll
      ??"");
      formDataToSend.append(
        "intermediate_maxmarks",
        formData.intermediate_maxmarks
      ??"");
      formDataToSend.append(
        "intermediate_obtmarks",
        formData.intermediate_obtmarks
      ??"");
      formDataToSend.append(
        "intermediate_percentage",
        formData.intermediate_percentage || ""
      );
      formDataToSend.append(
        "intermediate.subject",
        formData.intermediate_subject || ""
      );

      // Compulsory Subjects
      if (Array.isArray(formData.compulsory_subjects)) {
        formData.compulsory_subjects.forEach((subject) => {
          formDataToSend.append("compulsory_subjects[]", subject);
        });
      }

      // Declarations
      formDataToSend.append("is_ufmeans", formData.is_ufmeans??"");
      formDataToSend.append("has_scholarship", formData.has_scholarship??"");
      formDataToSend.append("is_casefiled", formData.is_casefiled??"");
      formDataToSend.append("is_rustigated", formData.is_rustigated??"");
      formDataToSend.append("is_civilservant", formData.is_civilservant??"");
      formDataToSend.append(
        "agreed_to_declaration",
        formData.agreed_to_declaration ? "1" : "0"
      );

      // Handle image and signature
      if (formData.image instanceof File) {
  formDataToSend.append("image", formData.image);
}

      if (formData.signature instanceof File) {
  formDataToSend.append("signature", formData.signature);
}

      const response = await axios.post(API_BASE_URL, formDataToSend);

      console.log(response.data["admission_code"]);

      return response.data;
    } catch (error) {
      console.log(error)
      console.error("Submission error:", error);
      let errorMessage = "An error occurred while submitting the form";

      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          error.response.statusText;
      } else if (error.request) {
        errorMessage = "No response received from server";
      }

      throw new Error(errorMessage);
    }
  },

  async validateStep(step, formData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const requiredFields = {
          1: [
            "urn",
            "applicant_name",
            "mother_name",
            "father_name",
            "dob",
            "gender",
            "religion",
            "category",
            "email",
            "applicant_mobile",
            "aadhar_no",
            "c_address",
          ],
          2: [
            "nationality",
            "is_minority",
            "is_otherenrollment",
            "is_upresidence",
          ],
          3: [
            "annual_income",
            "income_certificate_no",
            "bank_name",
            "branch",
            "account_no",
            "ifsc_code",
          ],
          4: [
            "high_school_year",
            "high_school_board",
            "high_school_name",
            "high_school_roll",
            "high_school_maxmarks",
            "high_school_obtmarks",
            "intermediate_year",
            "intermediate_board",
            "intermediate_name",
            "intermediate_roll",
            "intermediate_maxmarks",
            "intermediate_obtmarks",
          ],
          5: ["image", "signature"],
          6: [
            "is_ufmeans",
            "has_scholarship",
            "is_casefiled",
            "is_rustigated",
            "is_civilservant",
            "agreed_to_declaration",
          ],
        };

        const errors = [];
        const stepFields = requiredFields[step] || [];

        stepFields.forEach((field) => {
          if (field.includes(".")) {
            const [parent, child] = field.split(".");
            if (!formData[parent]?.[child]) {
              errors.push(field);
            }
          } else if (!formData[field]) {
            errors.push(field);
          }
        });

        resolve({
          valid: errors.length === 0,
          errors: errors.length > 0 ? errors : undefined,
        });
      }, 500);
    });
  },
};
